import { WebsiteLoader } from '@modules/loaders/interfaces/website-loader.interface';

export class LoaderHelper {
  _loader: WebsiteLoader;

  get loader(): WebsiteLoader {
    return this._loader || {
      color: '#000',
      type: 'spinner',
    };
  }

  set loader(value: WebsiteLoader) {
    if (value) {
      this._loader = value;
    }
  }
}
